var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
  'bold font-8',
  _vm.$vuetify.theme.dark ? 'white--text' : ''
],staticStyle:{"margin-bottom":"8px !important","color":"--var(text)"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }